// DO NOT UPDATE MANUALLY: Generated from script during build time
export const VERSION = '14.0.1-beta.20260715';
